import Slots from '@/shared/app/model/templating/Slots';
import Dataset from '@/shared/data/model/Dataset';
import { tmpCommAddToSlots } from '@/shared/marketing/tmp-comm-tools';

export const imgBox = (imgPath: string) => ({
  component: 'Box',
  config: {
    background: true,
    backgroundImage: true,
    backgroundImagePath: imgPath,
  },
});

export const commFournierTemp = (
  site: 'metztessy' | 'thones' | 'geg_grenoble' | 'arkema_marseille',
) => {
  const slots: Slots = {};
  const config: Dataset = {};

  // Communication commune
  // (à activer lorsqu'il n'y a aucune autre comm)
  tmpCommAddToSlots(slots, config, '/storage/comm/fournier_welcome.webp');

  // Communication spécifique à Thônes
  if (site === 'thones') {
    tmpCommAddToSlots(slots, config, '/storage/comm/fournier_saladespoke.jpg.webp');
    tmpCommAddToSlots(slots, config, '/storage/comm/fournier_streetfood_juin25.png.webp');
  }

  // Communication spécifique à Metz-Tessy
  if (site === 'metztessy') {
    tmpCommAddToSlots(slots, config, '/storage/comm/fournier_saladespoke.jpg.webp');
    tmpCommAddToSlots(slots, config, '/storage/comm/fournier_streetfood_juin25.png.webp');
  }

  if (site === 'geg_grenoble') {
    tmpCommAddToSlots(slots, config, '/storage/comm/geg_detox.png.webp');
  }

  // if (site === 'arkema_marseille') {
  //   tmpCommAddToSlots(slots, config, '/storage/comm/arkema_streetfood_juin25.png.webp');
  // }

  return { slots, config };
};
